import { FC, useEffect } from 'react';

import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { SimpleTooltip } from 'components/Tooltip/SimpleTooltip';

import { FormLabeledCheckbox } from 'components/UIkit/atoms/Checkbox';

interface OperatorReportCheckboxProps {
  isDisabled: boolean;
  testHook?: string;
}

export const OperatorReportCheckbox: FC<OperatorReportCheckboxProps> = ({
  isDisabled,
  testHook = 'operator-report-checkbox'
}) => {
  const { setValue } = useFormContext();

  // When disabled, ensure the checkbox is unchecked
  useEffect(
    function uncheckOperatorReportValueWhenDisabled() {
      if (isDisabled) {
        setValue('isIncludeOperatorReport', false);
      }
    },
    [isDisabled, setValue]
  );

  const checkbox = (
    <FormLabeledCheckbox
      label="Includes Reports to Operator (via Create Ticket Page)"
      name="isIncludeOperatorReport"
      disabled={isDisabled}
      testHook={testHook}
    />
  );

  return (
    <Box display="flex" alignItems="center">
      {isDisabled ? (
        <SimpleTooltip
          title={
            <div className="p-3">
              Symptoms reported via operator always have a minimum urgency of Nurse Review.
            </div>
          }
          placement="bottom"
          arrow
        >
          {checkbox}
        </SimpleTooltip>
      ) : (
        checkbox
      )}
    </Box>
  );
};
